import { render, staticRenderFns } from "./WhenToSignUpSubguidance.vue?vue&type=template&id=6d08aa02&lang=pug"
import script from "./WhenToSignUpSubguidance.vue?vue&type=script&lang=js"
export * from "./WhenToSignUpSubguidance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports